import React from 'react';
import { connect } from 'react-redux';
import Translate from 'translate';
import { Form } from 'react-form';
import moment from 'moment';
import Table from 'components/HTMLElements/Table/Custom';
import { toggleAlertError, toggleLoading } from 'stores/actions/';
import ReportService from 'services/ReportService';
import ChannelService from 'services/ChannelService';

import { FormGroup, InputDate, Select } from 'components/FormElements';
import IconMenu from 'material-ui/IconMenu';
import IconButton from 'material-ui/IconButton';
import NavigationExpandMoreIcon from 'material-ui/svg-icons/file/file-download';
import MenuItem from 'material-ui/MenuItem';
class EntriesPerHours extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      data: [],
      channelId: 0,
      dateFrom: new Date(),
      dateTo: new Date(),
      deleteModalOpened: false,
      channels: [  ],
    };
    this.download = '';
    this.search = {};
    this.getData = this.getData.bind(this);
    this.nombre = '';
  }
  componentDidMount() {
    const {chatActive, phoneActive} = this.props;
    let channels = [        
      {id:'facebook',name:'facebook'},
      {id:'twitter',name:'twitter'},
      {id:'email',name:'email'},
      {id:'walk_in',name:'walkin'},
    ];

    if (chatActive){
      channels.push( {id:'chat',name:'chat'})
    }

    if (phoneActive){
      channels.push( {id:'phone',name:'phone'})
    }
    this.setState({channels});
    this.getReport(this.params);
  }
  getData(params) {
    const { isLoading, toggleLoading } = this.props;
    this.params = _.cloneDeep(params);

    if (!isLoading) toggleLoading(true);

    ChannelService.getChannels({limit:-1}).then(response => {
      //toggleLoading(false);

      if (response.data) {
        this.setState({
          channels: response.data.data
        });
      }
    });

  }
  getReport(params) {
    const { isLoading, toggleLoading } = this.props;
    this.params = _.cloneDeep(params);
    
    if (!isLoading) toggleLoading(true);
    const apiParams = {
      date: moment(this.state.dateFrom).format('YYYY-MM-DD') ,
      //dateTo: moment(this.state.dateTo).format('YYYY-MM-DD') ,
      //types: this.state.channelId,
    };
    if (this.state.channelId !== 0 ) {
      apiParams.types = this.state.channelId
    }    
    if (this.download !== '' ) {
      apiParams.download = this.download
    }
    ReportService.getReportsEntriesPerHours(apiParams).then(response => {
      
      if (this.download !== '') {
        toggleLoading(false);
        window.location.href = response.data.uri;
      } else {
        toggleLoading(false);
        if (response.data) {
          this.nombre = '';
          this.setState({
            data: response.data
          });
        }
      }
    });
  }
  handleChange = e => {

    let x = []
    _.map( e, ( item, index ) => {
      //console.log( _.get( item, 'id' ) );
      x[index]=_.get( item, 'id' )

    });
    this.setState({ channelId: x});
  };
  handleDateChangeDateFrom = e => {
    this.setState({ dateFrom: e });
  };

  handleDateChangeDateTo = e => {
    this.setState({ dateTo: e });
  };

  submitForm = data => {
    this.search = data;
    //this.getReport(this.params);
  };

  render() {
    const { data, dateFrom, dateTo, channelId, channels} = this.state;
    return (
      <div className="box box-default">
        <div className="box-header d-flex justify-content-between">
          <h4>
            <Translate id="report.entriesPerHours" />
          </h4>
        </div>
        <div>
          <Form onSubmit={this.submitForm}>
            {({ submitForm }) => (
              <form onSubmit={submitForm} className="d-flex">

                <FormGroup containerClass="col-md-3">

                <label className={'MuiFormLabel-root MuiInputLabel-shrink'} style={{marginBottom:'0rem'}}><Translate id="report.channel"/></label>
                <Select field="sourceId" className="form-control" 
                        placeholder={<Translate id="report.selectChannel" />}
                        labelKey="name"
                        valueKey="id"
                        simpleValue={false} multi 
                        onChange={this.handleChange}
                        options={channels}/>
                </FormGroup>

                <FormGroup containerClass="col-md-3">
                  <InputDate
                    label={<Translate id="report.dateFrom" />}
                    value={dateFrom}
                    onChange={this.handleDateChangeDateFrom}
                  />
                </FormGroup>
                <div className="col-md-3 pl-0">
                  <button
                    style={{ marginTop: '0px' }}
                    type="submit"
                    className="btn btn-info mr-2 px-3"
                    onClick={() => {
                      this.search = {};
                      this.download = '';
                      this.getReport(
                        moment(dateFrom).format('DD-MM-YYYY'),
                        moment(dateTo).format('DD-MM-YYYY')
                      );
                    }}
                  >
                    <i className="fa fa-search pointer" />
                  </button>
                </div>

                <div className="col-md-2 pl-0 text-right">


                  <IconMenu style={{ height: '20px' }}
                        iconButtonElement={
                          <IconButton touch className="btn-account">
                            <NavigationExpandMoreIcon/>
                          </IconButton>
                        }>
                  <MenuItem
                    onClick={() => {
                      this.search = {};
                      this.download = 'excel';
                      this.getReport(
                        moment(dateFrom).format('DD-MM-YYYY'),
                        moment(dateTo).format('DD-MM-YYYY')
                      );
                    }}
                    key={1}
                    style={{ lineHeight: '25px', fontSize: '14px', minHeight: 'unset' }}
                    primaryText={''}> 
                    <i className="fa fa-file-excel-o pointer" /> CSV 
                  </MenuItem>
                  {/*<MenuItem
                    onClick={() => {
                      this.search = {};
                      this.download = 'pdf';
                      this.getReport(
                        value,
                        moment(dateFrom).format('DD-MM-YYYY'),
                        moment(dateTo).format('DD-MM-YYYY')
                      );
                    }}
                    key={2}
                    style={{ lineHeight: '25px', fontSize: '14px', minHeight: 'unset' }}
                    primaryText={''}> 
                    <i className="fa fa-file-pdf-o pointer" /> Pdf
                  </MenuItem>
                  */}
                  </IconMenu>
                </div>
              </form>
            )}
          </Form>
          <div className="box-body">
            <Table
              className="app-table-report"
              data={data}
              groupBy={['name']}
              sortable={false}
              columns={[
                {
                  Header: <Translate id="report.username" />,
                  accessor: 'name',
                  getProps: (state, rowInfo, column) => {
                    return {
                        style: {
                            background: rowInfo && rowInfo.row.inHour.toLowerCase().indexOf('total') !== -1? '#E9E9E9' : null,
                        },
                    };
                  },
                  Cell: props => {
                    const x = this.nombre !== props.original.name || props.viewIndex===0 ? props.original.name : ''
                    this.nombre =  props.original.name;
                    return props.original.inHour.toLowerCase().indexOf('total') !== -1 ? <div style={{fontWeight:'bold'}}>{x }</div> : x   
                  }
                },
                {
                  Header: <Translate id="report.inHour" />,
                  accessor: 'inHour',
                  getProps: (state, rowInfo, column) => {
                    return {
                        style: {
                            background: rowInfo && rowInfo.row.inHour.toLowerCase().indexOf('total') !== -1? '#E9E9E9' : null,
                        },
                    };
                  },
                  Cell: props => {
                    return props.original.inHour.toLowerCase().indexOf('total') !== -1 ? <div style={{fontWeight:'bold'}}>{props.value }</div> : props.value  
                  }
                  
                },
                {
                  Header: <Translate id="report.noAssigned" />,
                  accessor: 'noAssigned',
                  getProps: (state, rowInfo, column) => {
                    return {
                        style: {
                            background: rowInfo && rowInfo.row.inHour.toLowerCase().indexOf('total') !== -1? '#E9E9E9' : null,
                        },
                    };
                  },
                  Cell: props => {
                    return props.original.inHour.toLowerCase().indexOf('total') !== -1 ? <div style={{fontWeight:'bold'}}>{props.value }</div> : props.value  
                  }

                },
                {
                  Header: <Translate id="report.noRepliedTo" />,
                  accessor: 'noRepliedTo',
                  getProps: (state, rowInfo, column) => {
                    return {
                        style: {
                            background: rowInfo && rowInfo.row.inHour.toLowerCase().indexOf('total') !== -1? '#E9E9E9' : null,
                        },
                    };
                  },
                  Cell: props => {
                    return props.original.inHour.toLowerCase().indexOf('total') !== -1 ? <div style={{fontWeight:'bold'}}>{props.value }</div> : props.value  
                  }
                },
                {
                  Header: <Translate id="report.dismissed" />,
                  accessor: 'noDismissed',
                  getProps: (state, rowInfo, column) => {
                    return {
                        style: {
                            background: rowInfo && rowInfo.row.inHour.toLowerCase().indexOf('total') !== -1? '#E9E9E9' : null,
                        },
                    };
                  },
                  Cell: props => {
                    return props.original.inHour.toLowerCase().indexOf('total') !== -1 ? <div style={{fontWeight:'bold'}}>{props.value }</div> : props.value  
                  }
                }
              ]}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  isLoading: state.settings.isLoading,
  chatActive: state.settings.chatActive,
  phoneActive: state.settings.phoneActive,
});

const mapDispatchToProps = dispatch => ({
  toggleAlertError: message => {
    dispatch(toggleAlertError(message));
  },
  toggleLoading: isLoading => {
    dispatch(toggleLoading(isLoading));
  }
});

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)(EntriesPerHours);



// WEBPACK FOOTER //
// ./routes/app/routes/reports/EntriesPerHours/index.js